import React, { useMemo } from 'react';
import AddIcon from '@mui/icons-material//Add';
import { Button, Tooltip } from '@mui/material';
import theme from 'theme';
import { PlusItemButtonProps } from './PlusItemButton.props';

const PlusItemButton = ({
  isDocumentRequest,
  setOpenAddItemModal,
  isMaxCharactersError,
  formValues,
}: PlusItemButtonProps) => {
  const isNameInvalid = useMemo(
    () => !formValues.name || isMaxCharactersError,
    [formValues.name, isMaxCharactersError]
  );
  const isDocumentRequestAndNameInvalid = useMemo(
    () => isDocumentRequest && isNameInvalid,
    [isDocumentRequest, isNameInvalid]
  );
  const tooltipMessage = useMemo(
    () => (isDocumentRequestAndNameInvalid ? 'Document name is required' : ''),
    [isDocumentRequestAndNameInvalid]
  );

  const buttonStyles = useMemo(
    () => ({
      borderRadius: '4px',
      padding: '0.5rem 1rem',
      margin: '0.5rem 0',
      backgroundColor: isDocumentRequestAndNameInvalid ? theme.palette.grey[300] : theme.palette.grey[200],
      color: isDocumentRequestAndNameInvalid ? theme.palette.grey[500] : theme.palette.black,
    }),
    [isDocumentRequestAndNameInvalid]
  );

  const iconStyles = useMemo(
    () => ({
      color: isMaxCharactersError ? theme.palette.grey[600] : theme.palette.black,
    }),
    [isMaxCharactersError]
  );

  return (
    <Tooltip title={tooltipMessage} placement="top">
      <span>
        <Button
          fullWidth
          variant="outlined"
          style={buttonStyles}
          type={isDocumentRequest ? 'submit' : 'button'}
          onClick={isDocumentRequest ? undefined : () => setOpenAddItemModal(true)}
          disabled={isDocumentRequestAndNameInvalid}>
          <AddIcon style={iconStyles} />
        </Button>
      </span>
    </Tooltip>
  );
};

export default PlusItemButton;
